// @core/api/endpoints/product/delete_product_dependency.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/product';

/**
 * Delete product dependency
 * Removes a product dependency declaration. Existing tenant subscriptions are not affected but future validations will not include this dependency.
 */
export async function DeleteProductDependency(
  dependency_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/dependencies/:dependency_id`;
  requestPath = requestPath.replace(':dependency_id', encodeURIComponent(dependency_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
